import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { APIProvider } from '@vis.gl/react-google-maps';
import { AuthProvider } from './contexts/AuthContext';
import { TripProvider } from './contexts/TripContext';
import { ToastProvider } from './contexts/ToastContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import ToastContainer from './components/common/ToastContainer';
import HomePage from './pages/HomePage';
import TripsPage from './pages/TripsPage';
import CreateTripPage from './pages/CreateTripPage';
import TripDetailPage from './pages/TripDetailPage';
import SharedTripPage from './pages/SharedTripPage';
import ActivityDetailPage from './pages/ActivityDetailPage';
import JoinTripPage from './pages/JoinTripPage';
import InviteLinkPage from './pages/InviteLinkPage';
import MembersPage from './pages/MembersPage';
import EditTripPage from './pages/EditTripPage';
import PollsPage from './pages/PollsPage';
import PollDetailPage from './pages/PollDetailPage';
import TripRealtimeRoute from './components/common/TripRealtimeRoute';

const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;
const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY ?? '';

function App() {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <APIProvider apiKey={GOOGLE_MAPS_API_KEY}>
      <BrowserRouter>
        <AuthProvider>
          <TripProvider>
            <ToastProvider>
              <ToastContainer />
              <Routes>
              <Route path="/" element={<HomePage />} />
              {/* Public: JoinTripPage 自行處理未登入狀態，不包 ProtectedRoute，
                  避免導頁把邀請 token 弄丟（見 specs/006-/quickstart.md） */}
              <Route path="/join/:token" element={<JoinTripPage />} />
              {/* Protected routes - require authentication (FR-014) */}
              <Route
                path="/trips"
                element={
                  <ProtectedRoute>
                    <TripsPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/trips/new"
                element={
                  <ProtectedRoute>
                    <CreateTripPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/trips/:id"
                element={
                  <ProtectedRoute>
                    <TripRealtimeRoute>
                      <TripDetailPage />
                    </TripRealtimeRoute>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/trips/:id/itinerary/:itineraryId"
                element={
                  <ProtectedRoute>
                    <ActivityDetailPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/trips/:id/edit"
                element={
                  <ProtectedRoute>
                    <EditTripPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/trips/:id/invite"
                element={
                  <ProtectedRoute>
                    <InviteLinkPage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/trips/:id/members"
                element={
                  <ProtectedRoute>
                    <TripRealtimeRoute>
                      <MembersPage />
                    </TripRealtimeRoute>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/trips/:id/polls"
                element={
                  <ProtectedRoute>
                    <TripRealtimeRoute>
                      <PollsPage />
                    </TripRealtimeRoute>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/trips/:id/polls/:pollId"
                element={
                  <ProtectedRoute>
                    <TripRealtimeRoute>
                      <PollDetailPage />
                    </TripRealtimeRoute>
                  </ProtectedRoute>
                }
              />
              {/* Public share route - no auth required */}
              <Route path="/share/:shareCode" element={<SharedTripPage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </ToastProvider>
          </TripProvider>
        </AuthProvider>
      </BrowserRouter>
      </APIProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
